import { Trans } from 'react-i18next'

import growthPlanAnatomyPNG from '~/assets/images/anatomy/growth-plan-anatomy.png'
import growthPlanAnatomyWEBP from '~/assets/images/anatomy/growth-plan-anatomy.webp'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const GrowthPlanAnatomy = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Your growth plan is built on expert guidance',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={growthPlanAnatomyWEBP} type="image/webp" />
            <img src={growthPlanAnatomyPNG} alt="Growth Plan Anatomy" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.growthPlanAnatomy.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.growthPlanAnatomy.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default GrowthPlanAnatomy
